// src/Pages/Home/Home.jsx
import React, { useEffect } from 'react';
import Slider from './Slider'; 
import Action from './Calltoaction';
import Container from './container';
import Support from './Support';
import Popularproduct from './Popularproduct';
// import Category from './Category';
const Home = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [])
  return (
    <div style={{ textAlign: 'center', marginTop: '60px' }}>

      <Slider />
      <Container/>
      <Support />
      {/* <Category /> */}
      <Popularproduct />
      <Action />

    </div>
  );
};

export default Home;